import React from "react";
import { currencyFormatterShort } from "@common/helpers/currency";
import { flatRatePlanNames } from "@common/flatRateBilling";
import { OverPageBillingCTA } from "@components/billing/PlanManagement/OverPageBillingCTA";
import { useBillingManagement } from "@hooks/useBillingManagement";
import { useBillingStatus } from "@hooks/useBillingStatus";
import { Button } from "@design-system/Button/Button";
import { EndTrialAction } from "../../billing/AccessBlockedPage/EndTrialAction";
import { useSettings } from "../../settings/SettingsProvider";

export const ReportBillingCta: React.FC = () => {
    const { currentUsageLimit, canManageBilling, showUsageLimitReachedCta } =
        useBillingManagement();
    const { isTrialing, currentPlan } = useBillingStatus();
    const { open } = useSettings();

    if (!canManageBilling || (!isTrialing && !showUsageLimitReachedCta)) {
        return null;
    }

    if (showUsageLimitReachedCta) {
        return (
            <OverPageBillingCTA
                title={`You've reached the ${currencyFormatterShort.format(currentUsageLimit)} expense limit. Upgrade now for full access to historical data.`}
                cta={
                    <Button
                        onClick={() => open(["plans"])}
                        variant="tertiary"
                        size="md"
                        data-testid="cta-cover-button"
                    >
                        Upgrade
                    </Button>
                }
            />
        );
    }

    return (
        <OverPageBillingCTA
            title={
                <>
                    Your{" "}
                    <span className="text-blue-600">
                        {flatRatePlanNames[currentPlan]}
                    </span>{" "}
                    Trial includes up to 4 months of data. Start your
                    subscription now to get full access to your data.
                </>
            }
            cta={
                <EndTrialAction variant="tertiary">
                    Start subscription
                </EndTrialAction>
            }
        />
    );
};
